module.exports = __webpack_public_path__ + "img/icon-service-radius.caf2d887.svg";